import { useMutation } from '@tanstack/react-query'
import { createPaymentMethodSetupSession } from '../subscriptions'
import {
  buildPaymentMethodSetupReturnUrls,
  PaymentMethodSetupReturnOptions
} from '@utils/paymentMethodSetupReturn'

interface UsePaymentMethodSetupProps {
  slug: string
}

export const usePaymentMethodSetup = ({ slug }: UsePaymentMethodSetupProps) => {
  const mutation = useMutation({
    mutationFn: (options: PaymentMethodSetupReturnOptions = {}) =>
      createPaymentMethodSetupSession({ slug }, buildPaymentMethodSetupReturnUrls(options)),
    onSuccess: data => {
      if (!data.checkout_url) {
        return
      }
      window.location.href = data.checkout_url
    }
  })

  const startPaymentMethodSetup = (options: PaymentMethodSetupReturnOptions = {}) =>
    mutation.mutateAsync(options)

  return {
    startPaymentMethodSetup,
    isStartingPaymentMethodSetup: mutation.isPending
  }
}
